import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ImageFileUpload, postData } from "../../utility/Utility";
import CustomLoader from "../../Components/CustomLoader/CustomLoader";
import { useSearchParams } from "react-router-dom";


export default function UpdateInquiriesManagement() {
  const navigate = useNavigate();
  const location = useLocation();
  //   const [loading, setLoading] = useState(false)
  const [isDragging, setIsDragging] = useState(false)



  const [searchParams] = useSearchParams();
  const encodedData = searchParams.get("data");

  let datas = {};
  if (encodedData) {
    try {
      datas = JSON.parse(atob(decodeURIComponent(encodedData)));
    } catch (e) {
      console.error("Invalid data", e);
    }
  }

  console.log("datas", datas)

  const inquiry = location.state?.inquiry || datas;


  const [activeTab, setActiveTab] = useState('personal');
  const [selectedDocType, setSelectedDocType] = useState("")

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Format date for input fields (YYYY-MM-DD)
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleDownload = (url, fileName) => {
    if (!url) {
      toast.warning('No document available to download');
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.download = fileName || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const documentTypes = [
    { key: "aadhaarCard", label: "Aadhaar Card" },
    { key: "panCard", label: "PAN Card" },
    { key: "voterIdOrPassport", label: "Voter ID/Passport" },
    { key: "addressProof", label: "Address Proof" },
    { key: "dobProof", label: "Date of Birth Proof" },
    { key: "passportPhoto", label: "Passport Photo" },
    { key: "salarySlips", label: "Salary Slips" },
    { key: "bankStatement", label: "Bank Statement" },
    { key: "itr", label: "Income Tax Return" },
    { key: "medicalHistoryForm", label: "Medical History Form" },
    { key: "nomineeIdProof", label: "Nominee ID Proof" },
    { key: "healthCheckupReport", label: "Health Checkup Report" },
    { key: "existingHealthPolicy", label: "Existing Health Policy" },
  ];

  const [formData, setFormData] = useState({
    // Personal Info
    fullName: inquiry?.fullName || '',
    fatherName: inquiry?.fatherName || '',
    motherName: inquiry?.motherName || '',
    gender: inquiry?.gender || '',
    dateOfBirth: inquiry?.dateOfBirth ? formatDateForInput(inquiry.dateOfBirth) : '',
    maritalStatus: inquiry?.maritalStatus || '',
    spouseName: inquiry?.spouseName || '',
    hasChildren: inquiry?.hasChildren || 'No',
    children: inquiry?.children || [],

    // Contact Info
    emailId: inquiry?.emailId || '',
    mobileNumber: inquiry?.mobileNumber || '',
    alternateMobileNumber: inquiry?.alternateMobileNumber || '',

    // Health Info
    isSmoker: inquiry?.isSmoker || 'No',
    nationality: inquiry?.nationality || '',
    healthStatus: inquiry?.healthStatus || '',
    preExistingConditions: inquiry?.preExistingConditions || '',
    height: inquiry?.height || '',
    weight: inquiry?.weight || '',
    hasSurgeryHistory: inquiry?.hasSurgeryHistory || 'No',
    isOnMedication: inquiry?.isOnMedication || '',

    // Professional Info
    occupation: inquiry?.occupation || '',
    organizationName: inquiry?.organizationName || '',
    designation: inquiry?.designation || '',
    natureOfJob: inquiry?.natureOfJob || '',
    workExperience: inquiry?.workExperience || '',
    grossAnnualIncome: inquiry?.grossAnnualIncome || '',
    insuranceType: inquiry?.insuranceType || '',
    hasExistingInsurance: inquiry?.hasExistingInsurance || 'No',
    educationalQualification: inquiry?.educationalQualification || '',

    // Nominee Info
    nomineeName: inquiry?.nomineeName || '',
    nomineeDOB: inquiry?.nomineeDOB ? formatDateForInput(inquiry.nomineeDOB) : '',
    nomineeRelationship: inquiry?.nomineeRelationship || '',
    alternateNomineeName: inquiry?.alternateNomineeName || '',
    alternateNomineeRelationship: inquiry?.alternateNomineeRelationship || '',

    // System Info
    enquiryId: inquiry?.enquiryId || '',
    agentName: inquiry?.agentName || '',
    submissionDate: inquiry?.submissionDate ? formatDateForInput(inquiry.submissionDate) : '',
    signature: inquiry?.signature || '',
    createdAt: inquiry?.createdAt || '',
    updatedAt: inquiry?.updatedAt || '',

    // Documents
    documents: inquiry?.documents || {}
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (inquiry) {
      setFormData({
        // Personal Info
        fullName: inquiry.fullName || '',
        fatherName: inquiry.fatherName || '',
        motherName: inquiry.motherName || '',
        gender: inquiry.gender || '',
        dateOfBirth: inquiry.dateOfBirth ? formatDateForInput(inquiry.dateOfBirth) : '',
        maritalStatus: inquiry.maritalStatus || '',
        spouseName: inquiry.spouseName || '',
        hasChildren: inquiry.hasChildren || 'No',
        children: inquiry.children || [],

        // Contact Info
        emailId: inquiry.emailId || '',
        mobileNumber: inquiry.mobileNumber || '',
        alternateMobileNumber: inquiry.alternateMobileNumber || '',

        // Health Info
        isSmoker: inquiry.isSmoker || 'No',
        nationality: inquiry.nationality || '',
        healthStatus: inquiry.healthStatus || '',
        preExistingConditions: inquiry.preExistingConditions || '',
        height: inquiry.height || '',
        weight: inquiry.weight || '',
        hasSurgeryHistory: inquiry.hasSurgeryHistory || 'No',
        isOnMedication: inquiry.isOnMedication || '',

        // Professional Info
        occupation: inquiry.occupation || '',
        organizationName: inquiry.organizationName || '',
        designation: inquiry.designation || '',
        natureOfJob: inquiry.natureOfJob || '',
        workExperience: inquiry.workExperience || '',
        grossAnnualIncome: inquiry.grossAnnualIncome || '',
        insuranceType: inquiry.insuranceType || '',
        hasExistingInsurance: inquiry.hasExistingInsurance || 'No',
        educationalQualification: inquiry.educationalQualification || '',

        // Nominee Info
        nomineeName: inquiry.nomineeName || '',
        nomineeDOB: inquiry.nomineeDOB ? formatDateForInput(inquiry.nomineeDOB) : '',
        nomineeRelationship: inquiry.nomineeRelationship || '',
        alternateNomineeName: inquiry.alternateNomineeName || '',
        alternateNomineeRelationship: inquiry.alternateNomineeRelationship || '',

        // System Info
        enquiryId: inquiry.enquiryId || '',
        agentName: inquiry.agentName || '',
        submissionDate: inquiry.submissionDate ? formatDateForInput(inquiry.submissionDate) : '',
        signature: inquiry.signature || '',
        createdAt: inquiry.createdAt || '',
        updatedAt: inquiry.updatedAt || '',

        // Documents
        documents: inquiry.documents || {}
      });
    }
  }, [inquiry]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChildChange = (index, field, value) => {
    setFormData(prev => {
      const updatedChildren = [...prev.children];
      updatedChildren[index] = {
        ...updatedChildren[index],
        [field]: value
      };
      return {
        ...prev,
        children: updatedChildren
      };
    });
  };

  const handleAddChild = () => {
    setFormData(prev => ({
      ...prev,
      children: [...prev.children, { name: '', age: '', gender: '' }]
    }));
  };

  const handleRemoveChild = (index) => {
    setFormData(prev => ({
      ...prev,
      children: prev.children.filter((_, i) => i !== index)
    }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      // Upload all documents first
      const uploadedFiles = {};
      for (const doc of documentTypes) {
        if (formData.documents?.[doc.key]) {
          const file = formData.documents[doc.key];
          if (typeof file !== 'string') { // Only upload new files
            const formData = new FormData();
            formData.append('file', file);
            const response = await ImageFileUpload('api/admin/upload?is_upload=s3', formData);
            if (response?.success) {
              uploadedFiles[doc.key] = response.url;
            } else {
              throw new Error(`Failed to upload ${doc.label}`);
            }
          } else {
            uploadedFiles[doc.key] = formData.documents[doc.key];
          }
        }
      }

      // Prepare payload
      const payload = {
        ...formData,
        documents: uploadedFiles,
        // Remove system fields
        createdAt: undefined,
        updatedAt: undefined,
        enquiryId: undefined
      };


      // Submit to API
      const result = await postData('api/insurance-enquiry/submit', payload);

      if (result?.success) {
        toast.success('Inquiry updated successfully!');
        // Update local state with any returned data
        setFormData(prev => ({
          ...prev,
          ...result.data,
          documents: {
            ...prev.documents,
            ...result.data?.documents
          }
        }));
      } else {
        throw new Error(result?.message || 'Update failed');
      }
    } catch (error) {
      console.error('Error saving inquiry:', error);
      toast.error(error.message || 'Failed to update inquiry');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (docKey, e) => {
    setLoading(true);
    try {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      const response = await ImageFileUpload('api/admin/upload?is_upload=s3', formData);

      if (response?.success) {
        setFormData(prev => ({
          ...prev,
          documents: {
            ...prev.documents,
            [docKey]: response.url
          }
        }));
        toast.success('Document uploaded successfully!');
      } else {
        toast.error(response?.message || 'Document upload failed');
      }
    } catch (error) {
      console.error('Error uploading document:', error);
      toast.error('Network error during document upload');
    } finally {
      setLoading(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    setIsDragging(false)
  }

  const handleDrop = async (e) => {
    e.preventDefault()
    setIsDragging(false)

    if (!selectedDocType) {
      toast.warning("Please select a document type first")
      return
    }

    const file = e.dataTransfer.files[0]
    if (!file) return

    // Check file type
    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "application/pdf"]
    if (!validTypes.includes(file.type)) {
      toast.error("Please upload only images or PDF files")
      return
    }

    setLoading(true)
    try {
      const formDataUpload = new FormData()
      formDataUpload.append("file", file)

      const response = await ImageFileUpload("api/admin/upload?is_upload=s3", formDataUpload)

      if (response?.success) {
        setFormData((prev) => ({
          ...prev,
          documents: {
            ...prev.documents,
            [selectedDocType]: response.url,
          },
        }))
        toast.success("Document uploaded successfully!")
        setSelectedDocType("")
      } else {
        toast.error(response?.message || "Document upload failed")
      }
    } catch (error) {
      console.error("Error uploading document:", error)
      toast.error("Network error during document upload")
    } finally {
      setLoading(false)
    }
  }

  const handleRemoveDocument = (docKey) => {
    setFormData((prev) => {
      const newDocuments = { ...prev.documents }
      delete newDocuments[docKey]
      return {
        ...prev,
        documents: newDocuments,
      }
    })
    toast.success("Document removed successfully!")
  }

  const getUploadedDocuments = () => {
    return documentTypes.filter((doc) => formData.documents?.[doc.key])
  }



  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          {/* Header Section */}
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">Inquiry Management</h4>
              <p className="text-muted m-0">Enquiry ID: {inquiry?.enquiryId || 'N/A'}</p>
            </div>
            <div>
              <button className="btn btn-primary" onClick={() => navigate(-1)}>Back</button>
            </div>
          </div>

          {/* Role Tabs */}
          <div className="row mb-3">
            <div className="col-12">
              <ul className="nav nav-tabs nav-tabs-custom">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'personal' ? 'active' : ''}`}
                    onClick={() => handleTabChange('personal')}
                  >
                    Personal Info
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'professional' ? 'active' : ''}`}
                    onClick={() => handleTabChange('professional')}
                  >
                    Professional Info
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'documents' ? 'active' : ''}`}
                    onClick={() => handleTabChange('documents')}
                  >
                    Documents
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'system' ? 'active' : ''}`}
                    onClick={() => handleTabChange('system')}
                  >
                    System Info
                  </button>
                </li>
              </ul>

              {/* Personal Information Tab */}
              {activeTab === 'personal' && (
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">Personal Information</h4>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Full Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="fullName"
                            value={formData.fullName || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Father's Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="fatherName"
                            value={formData.fatherName || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Mother's Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="motherName"
                            value={formData.motherName || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Gender</label>
                          <select
                            className="form-select"
                            name="gender"
                            value={formData.gender || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Date of Birth</label>
                          <input
                            type="date"
                            className="form-control"
                            name="dateOfBirth"
                            value={formData.dateOfBirth || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Marital Status</label>
                          <select
                            className="form-select"
                            name="maritalStatus"
                            value={formData.maritalStatus || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select Status</option>
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Divorced">Divorced</option>
                            <option value="Widowed">Widowed</option>
                          </select>
                        </div>

                        {formData.maritalStatus === 'Married' && (
                          <div className="mb-3">
                            <label className="form-label">Spouse Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="spouseName"
                              value={formData.spouseName || ''}
                              onChange={handleChange}
                            />
                          </div>
                        )}

                        <div className="mb-3">
                          <label className="form-label">Has Children</label>
                          <select
                            className="form-select"
                            name="hasChildren"
                            value={formData.hasChildren || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        {formData.hasChildren === "Yes" && (
                          <div className="mb-3">
                            <label className="form-label">Children Details</label>
                            {formData.children.map((child, index) => (
                              <div key={index} className="mb-2 p-2 border rounded">
                                <div className="row">
                                  <div className="col-md-4">
                                    <label className="form-label">Name</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={child.name || ''}
                                      onChange={(e) => handleChildChange(index, 'name', e.target.value)}
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    <label className="form-label">Age</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={child.age || ''}
                                      onChange={(e) => handleChildChange(index, 'age', e.target.value)}
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    <label className="form-label">Gender</label>
                                    <select
                                      className="form-select"
                                      value={child.gender || ''}
                                      onChange={(e) => handleChildChange(index, 'gender', e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      <option value="Male">Male</option>
                                      <option value="Female">Female</option>
                                      <option value="Other">Other</option>
                                    </select>
                                  </div>
                                  <div className="col-md-2 d-flex align-items-end">
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => handleRemoveChild(index)}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                            <button
                              className="btn btn-sm btn-primary mt-2"
                              onClick={handleAddChild}
                            >
                              Add Child
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            name="emailId"
                            value={formData.emailId || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Mobile Number</label>
                          <input
                            type="tel"
                            className="form-control"
                            name="mobileNumber"
                            value={formData.mobileNumber || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Alternate Mobile</label>
                          <input
                            type="tel"
                            className="form-control"
                            name="alternateMobileNumber"
                            value={formData.alternateMobileNumber || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Smoker</label>
                          <select
                            className="form-select"
                            name="isSmoker"
                            value={formData.isSmoker || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Nationality</label>
                          <input
                            type="text"
                            className="form-control"
                            name="nationality"
                            value={formData.nationality || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Health Status</label>
                          <input
                            type="text"
                            className="form-control"
                            name="healthStatus"
                            value={formData.healthStatus || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Pre-existing Conditions</label>
                          <input
                            type="text"
                            className="form-control"
                            name="preExistingConditions"
                            value={formData.preExistingConditions || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Height (cm)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="height"
                            value={formData.height || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Weight (kg)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="weight"
                            value={formData.weight || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">Surgery History</label>
                          <select
                            className="form-select"
                            name="hasSurgeryHistory"
                            value={formData.hasSurgeryHistory || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Current Medication</label>
                      <input
                        type="text"
                        className="form-control"
                        name="isOnMedication"
                        value={formData.isOnMedication || ''}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="text-end">
                      <button className="btn btn-primary" onClick={handleSave}>
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Professional Information Tab */}
              {activeTab === 'professional' && (
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">Professional Information</h4>

                    <div className="row">
                      <div className="col-md-6">
                        <h5 className="mb-3">Employment Details</h5>

                        <div className="mb-3">
                          <label className="form-label">Occupation</label>
                          <input
                            type="text"
                            className="form-control"
                            name="occupation"
                            value={formData.occupation || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Organization Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="organizationName"
                            value={formData.organizationName || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Designation</label>
                          <input
                            type="text"
                            className="form-control"
                            name="designation"
                            value={formData.designation || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Nature of Job</label>
                          <input
                            type="text"
                            className="form-control"
                            name="natureOfJob"
                            value={formData.natureOfJob || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Work Experience (years)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="workExperience"
                            value={formData.workExperience || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Gross Annual Income</label>
                          <input
                            type="text"
                            className="form-control"
                            name="grossAnnualIncome"
                            value={formData.grossAnnualIncome || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <h5 className="mb-3">Insurance Details</h5>

                        <div className="mb-3">
                          <label className="form-label">Insurance Type</label>
                          <input
                            type="text"
                            className="form-control"
                            name="insuranceType"
                            value={formData.insuranceType || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Existing Insurance</label>
                          <select
                            className="form-select"
                            name="hasExistingInsurance"
                            value={formData.hasExistingInsurance || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Education</label>
                          <input
                            type="text"
                            className="form-control"
                            name="educationalQualification"
                            value={formData.educationalQualification || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <h5 className="mb-3 mt-4">Nominee Information</h5>

                        <div className="mb-3">
                          <label className="form-label">Nominee Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="nomineeName"
                            value={formData.nomineeName || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Nominee Date of Birth</label>
                          <input
                            type="date"
                            className="form-control"
                            name="nomineeDOB"
                            value={formData.nomineeDOB || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Nominee Relationship</label>
                          <input
                            type="text"
                            className="form-control"
                            name="nomineeRelationship"
                            value={formData.nomineeRelationship || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Alternate Nominee Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="alternateNomineeName"
                            value={formData.alternateNomineeName || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Alternate Nominee Relationship</label>
                          <input
                            type="text"
                            className="form-control"
                            name="alternateNomineeRelationship"
                            value={formData.alternateNomineeRelationship || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="text-end">
                      <button className="btn btn-primary" onClick={handleSave}>
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Documents Tab */}
              {/* {activeTab === 'documents' && (
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title mb-4">Document Upload</h4>

                                        <div className="row">
                                            {documentTypes.map((doc) => (
                                                <div className="col-md-4 mb-3" key={doc.key}>
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <h6 className="card-title">{doc.label}</h6>
                                                            {formData.documents?.[doc.key] ? (
                                                                <>
                                                                    {typeof formData.documents[doc.key] === 'string' ? (
                                                                        <>
                                                                            <div className="mb-2">
                                                                                <img
                                                                                    src={formData.documents[doc.key]}
                                                                                    alt={doc.label}
                                                                                    className="img-thumbnail"
                                                                                    style={{ maxHeight: "150px", width: "auto" }}
                                                                                />
                                                                            </div>
                                                                            <div className="d-flex gap-2">
                                                                                <button
                                                                                    className="btn btn-sm btn-primary"
                                                                                    onClick={() => handleDownload(formData.documents[doc.key], doc.label)}
                                                                                >
                                                                                    <i className="mdi mdi-download me-1"></i> Download
                                                                                </button>
                                                                                <label className="btn btn-sm btn-secondary mb-0">
                                                                                    <i className="mdi mdi-pencil me-1"></i> Change
                                                                                    <input 
                                                                                        type="file" 
                                                                                        hidden
                                                                                        onChange={(e) => handleFileChange(doc.key, e)}
                                                                                        accept="image/*,.pdf"
                                                                                    />
                                                                                </label>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <p className="text-success">Document submitted</p>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="d-grid">
                                                                    <label className="btn btn-sm btn-primary">
                                                                        <i className="mdi mdi-upload me-1"></i> Upload
                                                                        <input 
                                                                            type="file" 
                                                                            hidden
                                                                            onChange={(e) => handleFileChange(doc.key, e)}
                                                                            accept="image/*,.pdf"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="text-end">
                                            <button className="btn btn-primary" onClick={handleSave}>
                                                Save Changes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )} */}
              {activeTab === "documents" && (
                <div
                  className="card"
                  style={{
                    background: "linear-gradient(to bottom, #faf8f5 0%, #ffffff 100%)",
                    border: "2px solid #1e3a5f",
                    borderRadius: "12px",
                  }}
                >
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div>
                        <h4 className="mb-1" style={{ color: "#1e3a5f", fontWeight: "600" }}>
                          Document Management
                        </h4>
                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                          Upload and manage your insurance documents
                        </p>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className="badge"
                          style={{
                            background: "#ff6b6b",
                            color: "white",
                            padding: "8px 16px",
                            borderRadius: "20px",
                            fontSize: "13px",
                            fontWeight: "500",
                          }}
                        >
                          {getUploadedDocuments().length} / {documentTypes.length} Uploaded
                        </span>
                      </div>
                    </div>

                    <div className="row g-4">
                      {/* Left Column - Uploaded Documents List */}


                      {/* Right Column - Upload Area */}
                      <div className="col-lg-6">
                        <div
                          style={{
                            background: "white",
                            border: "2px solid #1e3a5f",
                            borderRadius: "12px",
                            padding: "24px",
                            minHeight: "500px",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <div
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                background: "#1e3a5f",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "14px",
                                fontWeight: "600",
                              }}
                            >
                              1
                            </div>
                            <h5 className="mb-0" style={{ color: "#1e3a5f", fontWeight: "600" }}>
                              Upload Document
                            </h5>
                          </div>

                          {/* Document Type Selector */}
                          <div className="mb-4">
                            <label
                              className="form-label"
                              style={{
                                color: "#1e3a5f",
                                fontWeight: "500",
                                fontSize: "14px",
                                marginBottom: "8px",
                              }}
                            >
                              Select Document Type
                            </label>
                            <select
                              className="form-select"
                              value={selectedDocType}
                              onChange={(e) => setSelectedDocType(e.target.value)}
                              style={{
                                border: "2px solid #1e3a5f",
                                borderRadius: "8px",
                                padding: "12px",
                                fontSize: "14px",
                                color: "#1e3a5f",
                                fontWeight: "500",
                              }}
                            >
                              <option value="">Choose a document type...</option>
                              {documentTypes.map((doc) => (
                                <option key={doc.key} value={doc.key}>
                                  {doc.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Upload Area */}
                          <div>

                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">

                        {selectedDocType ? (
                          <div
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            style={{
                              border: isDragging ? "3px dashed #ff6b6b" : "3px dashed #cbd5e0",
                              borderRadius: "12px",
                              padding: "48px 24px",
                              textAlign: "center",
                              background: isDragging ? "#fff5f5" : "#faf8f5",
                              transition: "all 0.3s",
                              cursor: "pointer",
                            }}
                          >
                            {selectedDocType && (
                              <div
                                className="mb-4"
                                style={{
                                  background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a8f 100%)",
                                  border: "2px solid #1e3a5f",
                                  borderRadius: "10px",
                                  padding: "16px 20px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "12px",
                                }}
                              >
                                <i
                                  className={documentTypes.find((doc) => doc.key === selectedDocType)?.icon || "mdi-file"}
                                  style={{
                                    fontSize: "32px",
                                    color: "#ff6b6b",
                                  }}
                                ></i>
                                <div>
                                  <p
                                    className="mb-0"
                                    style={{
                                      color: "#cbd5e0",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Uploading Document:
                                  </p>
                                  <h6
                                    className="mb-0"
                                    style={{
                                      color: "white",
                                      fontWeight: "600",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {documentTypes.find((doc) => doc.key === selectedDocType)?.label}
                                  </h6>
                                </div>
                              </div>
                            )}
                            <i
                              className="mdi mdi-cloud-upload"
                              style={{
                                fontSize: "64px",
                                color: isDragging ? "#ff6b6b" : "#1e3a5f",
                                marginBottom: "16px",
                              }}
                            ></i>
                            <h6
                              style={{
                                color: "#1e3a5f",
                                fontWeight: "600",
                                marginBottom: "8px",
                              }}
                            >
                              Drag and drop your file here
                            </h6>
                            <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
                              or click to browse
                            </p>
                            <label
                              className="btn mb-0"
                              style={{
                                background: "#ff6b6b",
                                color: "white",
                                border: "none",
                                padding: "12px 32px",
                                borderRadius: "8px",
                                fontWeight: "600",
                                fontSize: "14px",
                                cursor: "pointer",
                              }}
                            >
                              <i className="mdi mdi-upload me-2"></i>
                              Choose File
                              <input
                                type="file"
                                hidden
                                accept="image/*,.pdf"
                                onChange={(e) => handleFileChange(selectedDocType, e)}
                              />
                            </label>
                            <p className="text-muted mt-3 mb-0" style={{ fontSize: "12px" }}>
                              Supported formats: JPG, PNG, PDF (Max 10MB)
                            </p>
                          </div>
                        ) : (
                          <div
                            style={{
                              border: "2px dashed #cbd5e0",
                              borderRadius: "12px",
                              padding: "48px 24px",
                              textAlign: "center",
                              background: "#f8f9fa",
                            }}
                          >
                            <i
                              className="mdi mdi-file-document-outline"
                              style={{
                                fontSize: "64px",
                                color: "#cbd5e0",
                                marginBottom: "16px",
                              }}
                            ></i>
                            <p className="text-muted mb-0">Please select a document type first</p>
                          </div>
                        )}

                        {/* Info Box */}
                        <div
                          style={{
                            background: "#e8f4f8",
                            border: "1px solid #bee3f0",
                            borderRadius: "8px",
                            padding: "16px",
                            marginTop: "24px",
                          }}
                        >
                          <div className="d-flex gap-2">
                            <i
                              className="mdi mdi-information"
                              style={{
                                color: "#0c5460",
                                fontSize: "20px",
                              }}
                            ></i>
                            <div>
                              <h6
                                style={{
                                  color: "#0c5460",
                                  fontSize: "13px",
                                  fontWeight: "600",
                                  marginBottom: "4px",
                                }}
                              >
                                Document Guidelines
                              </h6>
                              <ul
                                className="mb-0 ps-3"
                                style={{
                                  color: "#0c5460",
                                  fontSize: "12px",
                                  lineHeight: "1.6",
                                }}
                              >
                                <li>Ensure documents are clear and readable</li>
                                <li>All text should be visible and not cut off</li>
                                <li>Upload original documents, not photocopies</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6 mt-4">
                      <div
                        style={{
                          background: "white",
                          border: "2px solid #1e3a5f",
                          borderRadius: "12px",
                          padding: "24px",
                          minHeight: "500px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              background: "#1e3a5f",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            2
                          </div>
                          <h5 className="mb-0" style={{ color: "#1e3a5f", fontWeight: "600" }}>
                            Uploaded Documents
                          </h5>
                        </div>

                        {getUploadedDocuments().length === 0 ? (
                          <div className="text-center py-5">
                            <i
                              className="mdi mdi-file-document-outline"
                              style={{
                                fontSize: "64px",
                                color: "#cbd5e0",
                                marginBottom: "16px",
                              }}
                            ></i>
                            <p className="text-muted mb-0">No documents uploaded yet</p>
                            <p className="text-muted" style={{ fontSize: "14px" }}>
                              Select a document type and upload your files
                            </p>
                          </div>
                        ) : (
                          <div className="d-flex flex-column gap-3">
                            {getUploadedDocuments().map((doc) => (
                              <div
                                key={doc.key}
                                style={{
                                  background: "#faf8f5",
                                  border: "1px solid #e2e8f0",
                                  borderRadius: "8px",
                                  padding: "16px",
                                  transition: "all 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.borderColor = "#1e3a5f"
                                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(30, 58, 95, 0.1)"
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.borderColor = "#e2e8f0"
                                  e.currentTarget.style.boxShadow = "none"
                                }}
                              >
                                <div className="d-flex gap-3">
                                  {/* Document Preview */}
                                  <div
                                    style={{
                                      width: "80px",
                                      height: "80px",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      border: "1px solid #e2e8f0",
                                      flexShrink: 0,
                                      background: "white",
                                    }}
                                  >
                                    {formData.documents[doc.key]?.toLowerCase().endsWith(".pdf") ? (
                                      <div className="d-flex align-items-center justify-content-center h-100">
                                        <i
                                          className="mdi mdi-file-pdf-box"
                                          style={{
                                            fontSize: "48px",
                                            color: "#ff6b6b",
                                          }}
                                        ></i>
                                      </div>
                                    ) : (
                                      <img
                                        src={formData.documents[doc.key] || "/placeholder.svg"}
                                        alt={doc.label}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    )}
                                  </div>

                                  {/* Document Info */}
                                  <div className="flex-grow-1">
                                    <div className="d-flex align-items-start justify-content-between mb-2">
                                      <div>
                                        <h6
                                          className="mb-1"
                                          style={{
                                            color: "#1e3a5f",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {doc.label}
                                        </h6>
                                        <span
                                          className="badge"
                                          style={{
                                            background: "#d4edda",
                                            color: "#155724",
                                            fontSize: "11px",
                                            fontWeight: "500",
                                            padding: "4px 8px",
                                          }}
                                        >
                                          <i className="mdi mdi-check-circle me-1"></i>
                                          Uploaded
                                        </span>
                                      </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="d-flex gap-2 mt-2">
                                      <button
                                        className="btn btn-sm"
                                        style={{
                                          background: "white",
                                          border: "1px solid #1e3a5f",
                                          color: "#1e3a5f",
                                          fontSize: "12px",
                                          padding: "4px 12px",
                                          borderRadius: "6px",
                                          fontWeight: "500",
                                        }}
                                        onClick={() => handleDownload(formData.documents[doc.key], doc.label)}
                                      >
                                        <i className="mdi mdi-download me-1"></i>
                                        Download
                                      </button>
                                      <button
                                        className="btn btn-sm"
                                        style={{
                                          background: "white",
                                          border: "1px solid #ff6b6b",
                                          color: "#ff6b6b",
                                          fontSize: "12px",
                                          padding: "4px 12px",
                                          borderRadius: "6px",
                                          fontWeight: "500",
                                        }}
                                        onClick={() => handleRemoveDocument(doc.key)}
                                      >
                                        <i className="mdi mdi-delete me-1"></i>
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="text-end mt-4">
                      <button
                        className="btn"
                        onClick={handleSave}
                        style={{
                          background: "#ff6b6b",
                          color: "white",
                          border: "none",
                          padding: "12px 32px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                      >
                        <i className="mdi mdi-content-save me-2"></i>
                        Save All Changes
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* System Information Tab */}
              {activeTab === 'system' && (
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">System Information</h4>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Enquiry ID</label>
                          <input
                            type="text"
                            className="form-control"
                            name="enquiryId"
                            value={formData.enquiryId || ''}
                            onChange={handleChange}
                            disabled
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Agent Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="agentName"
                            value={formData.agentName || ''}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Submission Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="submissionDate"
                            value={formData.submissionDate || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Created At</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formatDate(formData.createdAt) || ''}
                            disabled
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Updated At</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formatDate(formData.updatedAt) || ''}
                            disabled
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Signature</label>
                          <input
                            type="text"
                            className="form-control"
                            name="signature"
                            value={formData.signature || ''}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="text-end">
                      <button className="btn btn-primary" onClick={handleSave}>
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}